import { RequestHandler } from "./request_handler"
import { City, Prefecture } from "../types/area"
const CITIES_PATH = "/cities"

export interface GeolocationPosition {
  coords: {
    latitude: number
    longitude: number
  }
  timestamp: DOMTimeStamp
}

interface CityResponse {
  city?: City
  prefecture: Prefecture
}

// 1 PERMISSION_DENIED, 2 POSITION_UNAVAILABLE, 3 TIMEOUT
type GeolocationError = {
  code: number
  message: string
}

export class GeolocationHandler {
  latitude: number
  longitude: number
  enabled: boolean

  constructor() {
    this.enabled = "geolocation" in navigator
  }

  async getPosition(): Promise<GeolocationPosition["coords"]> {
    return new Promise((resolve, reject) => {
      if (!this.enabled) {
        return reject(new Error("Geolocation is not supported."))
      }
      const success = (pos: GeolocationPosition) => {
        resolve(pos.coords)
      }
      const failure = (error: GeolocationError) => {
        reject(error)
      }
      navigator.geolocation.getCurrentPosition(success, failure, {
        timeout: 30000,
        enableHighAccuracy: false,
      })
    })
  }

  async convertToCities(
    geo: GeolocationPosition["coords"]
  ): Promise<CityResponse[]> {
    const path = `${CITIES_PATH}?latitude=${geo.latitude}&longitude=${geo.longitude}`
    const handler = new RequestHandler(path, "GET")
    const res = await handler.requestWithBody()
    return res.body as CityResponse[]
  }
}
